import s from './styles.module.scss'
import { Link } from 'react-router-dom'

interface SubmitButtonProps {
    text: string
    btnType: string
    onClick: (event: React.MouseEvent) => void
    isSelected?: boolean
    disabled?: boolean
}

export const SubmitButtonMail = (props: SubmitButtonProps) => {
    const { text, onClick, btnType, disabled } = props
    return (
        <button
            onClick={onClick}
            className={`${s.cta} ${disabled ? s.disabled : ''} ${
                btnType == 'primary' ? s.primary : btnType == 'secondary' ? s.secondary : s.third
            }`}
            disabled={disabled}
        >
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const SubmitButton = (props: SubmitButtonProps) => {
    const { text, onClick, btnType, disabled } = props
    return (
        <button
            onClick={onClick}
            className={`${s.cta} ${
                btnType === 'primary' ? s.primary : btnType === 'secondary' ? s.secondary : s.third
            } ${disabled ? s.disabled : ''}`}
            disabled={disabled}
        >
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const OptionButton = (props: SubmitButtonProps) => {
    const { text, onClick, isSelected } = props
    return (
        <button
            onClick={onClick}
            className={`${s.selectOptionButton} ${isSelected ? s.selectedOption : s.unselectedOption}`}
        >
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const SelectButton = (props: SubmitButtonProps) => {
    const { text, onClick, isSelected } = props
    return (
        <button onClick={onClick} className={`${s.selectButton} ${isSelected ? s.selected : s.unselected}`}>
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const CtaButton = (props: { text: string; url?: string }) => {
    const { text, url } = props
    const onClick = () => {
        console.log('scroll to top....')
        // window.scrollTo({ top: 0, behavior: "smooth" });
        if (url) {
            window.location.href = url
        } else {
            window.location.href = '/claim/start'
        }
    }
    return (
        <button onClick={onClick} className={s.ctaButton}>
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const CtaButtonmbFinanceCheck = (props: { text: string; url?: string }) => {
    const { text, url } = props
    const onClick = () => {
        console.log('scroll to top....')
        // window.scrollTo({ top: 0, behavior: "smooth" });
        if (url) {
            window.location.href = url
        } else {
            window.location.href = '/claim/start'
        }
    }
    return (
        <button onClick={onClick} className={`${s.ctaButton} ${s.mbFinanceCheck}`}>
            <span>{text}</span>
            {/* <img src={btnType == "secondary" ? goldArrow : blackArrow} /> */}
        </button>
    )
}

export const BackButton = (props: { onClick: (event: React.MouseEvent) => void }) => {
    const { onClick } = props
    return (
        <button onClick={onClick} className={s.backButton}>
            <span>← Back</span>
        </button>
    )
}
